/** @jsx jsx */

import { jsx } from '@balance-web/core';
import { Inline } from '@balance-web/inline';
import { useTheme } from '@balance-web/theme';
import { Flex } from '@balance-web/flex';
import { Box } from '@balance-web/box';

import { AppSwitcher } from './AppSwitcher';
import { AppInfo } from './AppInfo';
import { UserMenu } from './UserMenu';
import type { AppHeaderConfig } from './types';
import { Navigation } from './Navigation';
import { UtilityActionsRenderer } from './UtilityActionsRenderer';

export type AppHeaderProps = AppHeaderConfig;
export const AppHeader = ({
  appName,
  appVersion,
  appIconUrl,
  appSwitcher,
  pages,
  selectedPage,
  bookInfo,
  userMenu,
  utilityActions,
  globalActions,
  isLoading,
}: AppHeaderProps) => {
  const { semantic, borderWidth } = useTheme();

  return (
    <Box>
      {isLoading ? (
        <Box height={APP_HEADER_HEIGHT} />
      ) : (
        <Inline
          css={{
            alignItems: 'stretch',
            borderBottom: `${borderWidth.standard} solid ${semantic.colour.surface.neutral.border}`,
          }}
          height={APP_HEADER_HEIGHT}
          paddingX="large"
          width="100%"
        >
          {appSwitcher && <AppSwitcher {...appSwitcher} />}
          <Flex alignItems="center" paddingLeft="small">
            <AppInfo
              appIconUrl={appIconUrl}
              appName={appName}
              bookName={bookInfo?.bookName}
              onClick={bookInfo?.onClick}
            />
          </Flex>

          {selectedPage && pages?.length ? (
            <Navigation
              globalActions={globalActions}
              pages={pages}
              selectedPage={selectedPage}
            />
          ) : (
            <div css={{ flex: 1 }} />
          )}

          <Inline alignY="center" gap="large">
            <UtilityActionsRenderer utilityActions={utilityActions} />
            {userMenu && <UserMenu appVersion={appVersion} {...userMenu} />}
          </Inline>
        </Inline>
      )}
    </Box>
  );
};

const APP_HEADER_HEIGHT = 64;
